<template>
  <div class="page">
    <div class="town-tab-container">
      <div class="tab-item active" data-town-name="traditional" @click="showTown($event)">
        TRADITIONAL TOWNS
      </div>
      <div class="tab-item" data-town-name="urban" @click="showTown($event)">
        URBAN TOWNS
      </div>
    </div>
    <div class="town-content">
      <div class="content active" data-town-select="traditional">
        <div class="floorplans" v-for="(floorplan, index) in getTown('traditional towns').data"
          :key="floorplan.name + index" @click="showFloorplan(floorplan)" :class="{'greyed-out': floorplan.greyedOut}">
          <div class="display-image">
            <img :src="floorplan.image.display" :alt="floorplan.name">
          </div>
          <div class="name">
            {{floorplan.name}}
            <span class="category" v-if=" floorplan['sub-category'] !='' ">
              {{ floorplan['sub-category'] }}
            </span>
          </div>
          <div class="sqft">
            {{Object.values(floorplan.sqft)[0].toLocaleString()}} SQ.FT.
          </div>
          <div class="bedrooms">
            {{floorplan.rooms.bed}} BEDROOMS
          </div>
        </div>
      </div>
      <div class="content" data-town-select="urban">
        <div class="floorplans" v-for="(floorplan, index) in getTown('urban towns').data" :key="floorplan.name + index"  :class="{'greyed-out': floorplan.greyedOut}"
          @click="showFloorplan(floorplan)">
          <div class="display-image">
            <img :src="floorplan.image.display" :alt="floorplan.name">
          </div>
          <div class="name">
            {{floorplan.name}}
            <span class="category" v-if=" floorplan['sub-category'] !='' ">
              {{ floorplan['sub-category'] }}
            </span>
          </div>
          <div class="sqft">
            {{Object.values(floorplan.sqft)[0].toLocaleString()}} SQ.FT.
          </div>
          <div class="bedrooms">
            {{floorplan.rooms.bed}} BEDROOMS
          </div>
        </div>
      </div>
    </div>
    <transition name="floorplandetail-animation" enter-active-class="animated fadeInUp" leave-active-class="fadeOutDonw" mode="out-in">
      <floorplanDetail class="floorplan-details" v-if="floorplanVisibility" :floorplan="currentFloorplanDetail"
        @close="closeDetail()">
      </floorplanDetail>
    </transition>
  </div>
</template>

<script>
  import floorplanDetail from './FloorplanDetail.vue';

  export default {
    name: "floorplans",
    props: ['townname'],
    components: {
      floorplanDetail
    },
    data() {
      return {
        townContent: "",
        townTab: "",
        floorplanVisibility: false,
        currentFloorplanDetail: "",
        currentTown: ""
      }
    },
    activated() {
      this.currentTown = this.$route.query.townname || 'traditional';
      let temp = document.querySelector(".town-tab-container [data-town-name='" + this.currentTown + "']");
     
      this.townContent = document.querySelectorAll('.town-content .content');
      this.townTab = document.querySelectorAll(".town-tab-container .tab-item");
      temp.click();
    },
    beforeRouteLeave (to, from, next) {
      // ...
      this.floorplanVisibility = false;
      next();
    },
    methods: {
      showTown($event) {     
        let townName = $event.target.dataset.townName;       

        this.townContent.forEach((element) => {
          if (element.dataset.townSelect == townName) {
            element.style.display = "flex";
            element.classList.add("active");
          } else {
            element.style.display = "none";
            element.classList.remove("active");
          }
        });

        [...this.townTab].forEach((element) => {
          if (element.dataset.townName == townName) {
            element.classList.add("active");            
          } else {
            element.classList.remove("active");
          }
        });

      }, //showTown
      showFloorplan(floorplan) {
        this.floorplanVisibility = true;
        this.currentFloorplanDetail = floorplan

      },
      closeDetail() {
        this.floorplanVisibility = false;
      }
    }
  }
</script>

<style lang="scss" scoped>
  .page {
    padding: 90px 0;

  }
.greyed-out{
  filter: grayscale(1) opacity(0.3);
  pointer-events: none !important;
}
  .town-tab-container {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    font-size: 80px;
    letter-spacing: 0.07em;

    .tab-item {
      flex: 0 1 auto;
      color: #B5B5B5;
      padding: 0 20px;

      &.active {
        color: #0071CE;
        border: 2px solid #0071CE;
      }
    }
  }

  .town-content {
    display: flex;
    justify-content: center;
    width: 100%;

    .content {
      padding: 80px 0 0 0;
      flex: 0 1 100%;
      display: none;
      justify-content: space-between;
      align-items: flex-start;

      &.active {
        display: flex;
      }

      img {
        max-width: 100%;
      }

      .floorplans {
        flex: 0 1 20%;
        padding: 0 5px;
        font-family: 'EngraversGothicBTW01-Re';
        text-align: center;
        text-transform: uppercase;

        .name {
          color: #0071CE;
          font-size: 40px;
          padding: 5px 0;

          .category {
            font-size: 14px;
            padding: 5px 0 0 0;
            display: block;
            width: 100%;
          }
        }

        .sqft,
        .bedrooms {
          font-size: 18px;
          padding: 5px 0;
        }
      }
    }
  }
</style>